import { useAuth as useFronteggAuth } from "@frontegg/react";

const DEV_AUTH_BYPASS = import.meta.env.DEV && import.meta.env.VITE_DEV_AUTH_BYPASS === "true";

const DEV_STUB_USER = {
  id: "dev-user-123",
  email: "dev@test.fixfinder.com",
  name: "Dev Test User",
  tenantId: "dev-tenant-123",
};

export function useDevAuth() {
  const fronteggAuth = useFronteggAuth();
  
  if (DEV_AUTH_BYPASS) {
    return {
      isAuthenticated: true,
      user: DEV_STUB_USER,
      isLoading: false,
    };
  }
  
  return {
    isAuthenticated: fronteggAuth.isAuthenticated,
    user: fronteggAuth.user,
    isLoading: fronteggAuth.isLoading,
  };
}
